import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function SuperLoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await api.post("/auth/super-login", formData);
      localStorage.setItem("obihub_super_token", response.access_token);
      toast.success("Super admin girişi başarılı");
      navigate("/super/panel");
    } catch (error) {
      toast.error(error.message || "Super admin girişi başarısız");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-950 p-6">
      <div className="w-full max-w-md rounded-2xl border border-slate-800 bg-slate-900 p-6">
        <h1 className="text-xl font-semibold text-white">Super Admin Girişi</h1>
        <p className="mt-1 text-sm text-muted-foreground">Platform yönetimi için ayrı giriş.</p>

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div className="space-y-2">
            <Label htmlFor="super-email" className="text-slate-300">E-posta</Label>
            <Input
              id="super-email"
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              placeholder="superadmin@obihub.com"
              required
              className="h-10 bg-slate-800 border-slate-700 text-slate-100"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="super-password" className="text-slate-300">Şifre</Label>
            <Input
              id="super-password"
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              placeholder="Super admin şifresi"
              required
              className="h-10 bg-slate-800 border-slate-700 text-slate-100"
            />
          </div>
          <Button
            type="submit"
            disabled={loading}
            className="w-full h-10 bg-sky-600 hover:bg-sky-500 text-white"
          >
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Super Admin Giriş
          </Button>
        </form>
      </div>
    </div>
  );
}

